import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import LogTabs from "./tabs/LogTabs";
import ConfigurationLogsPageContent from "./content/ConfigurationLogsPageContent";
import SystemLogsPageContent from "./content/SystemLogsPageContent";
import LicenseLogsPageContent from "./content/LicenseLogsPageContent";
import SoftwareLogsPageContent from "./content/SoftwareLogsPageContent";
import AuthLogsPageContent from "./content/AuthLogsPageContent";
import AuditFailurePageContent from "./content/AuditFailurePageContent";
import { getStorageStatus } from "src/app/services";
import { USER_NAME_ROLE } from "src/app/auth";
import SystemHealthLogsPageContent from "./content/SystemHealthLogsPageContent";

const LogsPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [storageData, setStorageData] = useState<{
    used?: number;
    max?: number;
    percent?: number;
  }>({});

  useEffect(() => {
    const fetchStorage = async () => {
      try {
        getStorageStatus().then((res) => {
          setStorageData({
            max: res.data.data.max_log_storage_mb,
            used: res.data.data.estimated_log_storage_mb,
            percent: res.data.data.percent_used,
          });
        }).catch((err) => {
          console.error("Error clearing system status logs: ", err);
        });
      } catch (err) {
        console.error("Failed to fetch storage info", err);
      }
    };

    fetchStorage();
  }, []);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      {
        sessionStorage.getItem(USER_NAME_ROLE) === "admin" && <Box sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: 1,
          fontWeight: 600
        }}>
          {storageData.percent !== undefined ? (
            <>
              Storage Usage: <strong>({storageData.percent.toFixed(2)}%)</strong>
              {/* {storageData.used?.toFixed(3)} / {storageData.max} MB (
            {storageData.percent.toFixed(2)}%) */}
            </>
          ) : (
            "Storage Usage: Loading..."
          )}
        </Box>
      }
      <LogTabs activeTab={activeTab} handleChange={handleChange} />
      <Box sx={{ mt: 2 }}>
        {activeTab === 0 && <ConfigurationLogsPageContent />}
        {activeTab === 1 && <SoftwareLogsPageContent />}
        {activeTab === 2 && <SystemHealthLogsPageContent />}
        {activeTab === 3 && <SystemLogsPageContent />}
        {activeTab === 4 && <LicenseLogsPageContent />}
        {activeTab === 5 && <AuthLogsPageContent />}
        {activeTab === 6 && <AuditFailurePageContent />}
      </Box>
    </Box>
  );
};

export default LogsPage;
